import React, { useEffect, useState } from "react";
import { ComboBox, FormSection } from "../../../components";
import FormCustomDropdown from "../../../components/forms/FormCustomDropdown";

import { Sexo, Categoria, Variedade, Pais } from "../../../types";

interface FormAgrupamentoProps {
  sexos: Sexo[];
  categorias: Categoria[];
  variedades: Variedade[];
  paises: Pais[];
  handleConsulta: any;
}

interface ConsultaInterface {
  categoria?: number | string;
  sexo?: number | string;
  variedade?: number | string;
  pais?: number | string;
}

const FormAgrupamento: React.FC<FormAgrupamentoProps> = ({
  sexos,
  categorias,
  variedades,
  handleConsulta,
  paises,
}) => {
  const [consulta, setConsulta] = useState<ConsultaInterface>({});
  const [depsOpen, setDepsOpen] = useState(true);
  const [inputDropdownCategoria, setInputDropdownCategoria] = useState("");
  const [inputDropdownSexo, setInputDropdownSexo] = useState("");
  const [inputDropdownVariedade, setInputDropdownVariedade] = useState("");
  const [inputDropdownPais, setInputDropdownPais] = useState("");

  const handleInputCategoria = (value: Categoria) => {
    setInputDropdownCategoria(value.nome);
    setConsulta({ ...consulta, categoria: value.codigo });
  };

  const handleInputSexo = (value: Sexo) => {
    setInputDropdownSexo(value.nome);
    setConsulta({ ...consulta, sexo: value.id });
  };

  const handleInputVariedade = (value: Variedade) => {
    setInputDropdownVariedade(value.nome);
    setConsulta({ ...consulta, variedade: value.codigo });
  };

  const handleInputPais = (value: Pais) => {
    setInputDropdownPais(value.nome);
    setConsulta({ ...consulta, pais: value.codigo });
  };

  useEffect(() => {
    handleConsulta(consulta);
  }, [consulta]);

  return (
    <div className="main-content">
      <FormSection title="Agrupamentos" borderBottomWidth={241}>
        <ComboBox
          // name="categoria"
          value={inputDropdownCategoria}
          items={categorias}
          placeholder="Categoria"
          handleInput={handleInputCategoria}
          displayName="nome"
        />

        <ComboBox
          // name="variedade"
          value={inputDropdownVariedade}
          items={variedades}
          placeholder="Variedade"
          handleInput={handleInputVariedade}
          displayName="nome"
        />

        <ComboBox
          // name="sexo"
          value={inputDropdownSexo}
          items={sexos}
          placeholder="Sexo"
          handleInput={handleInputSexo}
          displayName="nome"
        />

        <ComboBox
          // name="pais"
          value={inputDropdownPais}
          items={paises}
          placeholder="Pais de origem"
          handleInput={handleInputPais}
          displayName="nome"
        />
      </FormSection>
    </div>
  );
};

export default FormAgrupamento;